
export function createRenderTreeItem({
    hasMoreAtDepthMap,
    handleRenderNode,
    indentSize,
    connectorGap = 3,
}) {
    // This function has the exact signature react-complex-tree expects
    return function renderTreeItem({ item, depth, title, arrow, context, children }) {
        const safeDepth = Math.max(0, depth ?? 0);
        const node = { item, title, context };

        const colStates = hasMoreAtDepthMap[item.index] || []; // [bool,bool,...]

        const { style: interactiveStyle = {}, ...restInteractive } =
            context.interactiveElementProps || {};

        const cleanedInteractiveStyle = {
            ...interactiveStyle,
            marginLeft: 0,
        };

        return (
            <li
                {...context.itemContainerWithChildrenProps}
                className="rct-tree-item"
            >
                <div
                    {...context.itemContainerWithoutChildrenProps}
                    {...restInteractive}
                    style={cleanedInteractiveStyle}
                    className="rct-row-inner"
                >
                    {/* Gutter: fixed-width flex item so rails stay consistent */}
                    <div
                        className="line-gutter"
                        style={{
                            width: safeDepth * indentSize,
                            flex: "0 0 auto", // don't shrink/grow this
                        }}
                    >
                        {Array.from({ length: safeDepth }).map((_, i) => {
                            const isParentColumn = i === safeDepth - 1;
                            const continuesBelow = colStates[i] ?? false;

                            // Ancestor columns: only draw if the rail continues below.
                            if (!isParentColumn && !continuesBelow) {
                                return null;
                            }

                            // Parent column: always draw; if it does NOT continue below,
                            // use the "last" variant that stops at the node.
                            const extraClass =
                                isParentColumn && !continuesBelow ? " line-vert--last" : "";

                            const columnCenter = i * indentSize + indentSize / 2;

                            return (
                                <div
                                    key={i}
                                    className={`line-vert${extraClass}`}
                                    style={{ left: `${columnCenter}px` }}
                                />
                            );
                        })}

                        {safeDepth > 0 && (
                            <div
                                className="line-horiz"
                                style={{
                                    left: `${(safeDepth - 1) * indentSize + indentSize / 2}px`,
                                    width: indentSize / 2,
                                }}
                            />
                        )}
                    </div>

                    {/* Node content: flex row that takes remaining width */}
                    <div
                        className="node-content d-flex align-items-center flex-grow-1 mr-3"
                        style={{
                            paddingLeft: connectorGap, // gap between line tip and node
                            gap: 4,                     // arrow-node gap
                        }}
                    >
                        {arrow}
                        {handleRenderNode(node)}
                    </div>
                </div>

                {children}
            </li>
        );
    };
}
